import {
  FaqAccordion,
  FaqAccordionProps,
} from '@src/components/faq-accordion/FaqAccordion.component'
import classNames from 'classnames'
import type { ReactNode } from 'react'
import styles from './FaqsSection.module.scss'

export interface FaqsSectionProps extends FaqAccordionProps {
  heading?: string
  fullWidth?: boolean
}

export function FaqsSection({ heading, theme = 'grey', ...rest }: FaqsSectionProps): ReactNode {
  return (
    <section className={classNames(styles.FaqsSection, styles[`FaqsSection___${theme}`])}>
      <div className={styles.FaqsSection__layout}>
        {heading && <h2 className={styles.FaqsSection__heading}>{heading}</h2>}
        <FaqAccordion headingLevel={3} theme={theme} {...rest} />
      </div>
    </section>
  )
}
